import axios from 'utils/axios';

export const getPhotoTags = () => axios.get('/api/admin/photo-tags');
